module.exports = __webpack_public_path__ + "img/cong-icon.696e8634.svg";